import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LoginComponent, RegisterComponent, ForgetPasswordComponent
  , VendorRegisterProfileComponent, VendorRegisterProfile1Component,ResetPasswordComponent,RegistrationStatusComponent
  } from './components';
import { EmailUnsubscribeComponent } from './components/email-unsubscribe/email-unsubscribe.component';


export const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },
 // { path: 'register', component: RegisterComponent },
  { path: 'forget-password', component: ForgetPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
 // { path: 'register-profile', component: VendorRegisterProfileComponent },
 // { path: 'register-profile1', component: VendorRegisterProfile1Component },
  { path: 'email-unsubscribe/:userReferenceId/:userEmail', component: EmailUnsubscribeComponent },
  { path: 'registration-status', component: RegistrationStatusComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
